var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { withStyles as muiWithStyles } from "@material-ui/styles";
import { theme } from "./theme";
export function withStyles(style, options) {
    return muiWithStyles(style, __assign(__assign({}, options), { defaultTheme: theme }));
}
